import React from 'react';

export default function Bot() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_6193)'
      />
      <path
        d='M7.02344 17.7252C7.02344 13.7249 10.2664 10.4821 14.2667 10.4821H19.7566C23.7569 10.4821 26.9999 13.7249 26.9999 17.7252C26.9999 21.7254 23.7569 24.9683 19.7566 24.9683H14.2667C10.2664 24.9683 7.02344 21.7254 7.02344 17.7252Z'
        fill='#3868C7'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.03084 5C8.15244 5 9.06168 5.90921 9.06168 7.03078V17.7262H7.03084H5L5 7.03078C5 5.90921 5.90924 5 7.03084 5Z'
        fill='#76C451'
      />
      <path
        d='M16.5112 17.7265C16.5112 18.8481 15.6117 19.7573 14.5021 19.7573C13.3926 19.7573 12.4932 18.8481 12.4932 17.7265C12.4932 16.6049 13.3926 15.6957 14.5021 15.6957C15.6117 15.6957 16.5112 16.6049 16.5112 17.7265Z'
        fill='white'
      />
      <path
        d='M22.8715 17.7265C22.8715 18.8481 21.972 19.7573 20.8625 19.7573C19.7529 19.7573 18.8535 18.8481 18.8535 17.7265C18.8535 16.6049 19.7529 15.6957 20.8625 15.6957C21.972 15.6957 22.8715 16.6049 22.8715 17.7265Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5 17.7261C5 12.6058 9.14833 8.45227 14.2688 8.45227H15.3573C16.4788 8.45227 17.3881 9.36148 17.3881 10.483C17.3881 11.6046 16.4788 12.5139 15.3573 12.5139H14.2688C11.3944 12.5139 9.06168 14.8461 9.06168 17.7261C9.06168 20.6062 11.3944 22.9384 14.2688 22.9384H19.5317C20.6534 22.9384 21.5626 23.8477 21.5626 24.9692C21.5626 26.0908 20.6534 27.0001 19.5317 27.0001H14.2688C9.14833 27.0001 5 22.8465 5 17.7261Z'
        fill='#76C451'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_6193'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#2B3238' />
          <stop offset='1' stop-color='#202D39' />
        </linearGradient>
      </defs>
    </svg>
  );
}
